import { Card, Text, Menu } from "@mantine/core";
import React from "react";

export default function FlashcardCard({
  setId,
  cardId,
  front,
  back,
  onEditClick,
  onDeleteClick,
}) {
  return (
    <Menu transition="rotate-right" shadow="md" width={200} offset={-10}>
      <Menu.Target>
        <Card className="flashcardCard"
          style={{
            borderRadius: "10px",
            maxWidth: "300px",
            height: "200px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Text style={{ position: "relative" }} align="center" weight={700}>
            {front}
          </Text>
          <Text align="center">{back}</Text>
        </Card>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Label>Card Menu</Menu.Label>
        <Menu.Item onClick={() => onEditClick(setId, cardId)}>
          Edit Card
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item color="red" onClick={() => onDeleteClick(setId, cardId)}>
          Delete Card
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
